import { gql } from '@apollo/client';

const Fragments = {
  scoringCategoryItem: gql`
    fragment scoringCategoryItem on ScoringCategoryItem {
      scoringId
      orderNo
      scoringCode
      scoringName
      computed
      formula
      inputTypeId
      scale
      sensitiveInfo
    }
  `,
  scoringCategoryDetailItem: gql`
    fragment scoringCategoryDetailItem on ScoringCategoryDetailItem {
      scoringDetailId
      scoringId
      description
      score
      freeTxt
      scoringDetailName
      parentScoringDetailId
      orderNo
      code
      defaultYN
      minValue
      maxValue
    }
  `
};

export default Fragments;
